import { RATE_LIMIT_UNITS } from '../../BaseSendEditor.constants';

export const DEFAULT_LIMIT = 1000;
export const DEFAULT_UNIT = RATE_LIMIT_UNITS.MINUTE;

const createOption = (u: string) => ({ id: u, value: u, label: u });
export const rateUnitOptions = Object.values(RATE_LIMIT_UNITS).map(createOption);
